import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '../../store'
import { useProvisionedTeams } from '../redux/provisioned/hooks'
import { reloadVisibleAccounts, reloadTeam, reloadScopes } from '../redux/users/slice'
import { updateForceRefresh } from '../redux/sessions/lists/list-slice'
import { setReset } from '../redux/analytics/slice'

export function useTeamDataRefresh() {
  const dispatch = useDispatch<AppDispatch>()
  const { selectedTeamId } = useProvisionedTeams()
  
  useEffect(() => {
    if (selectedTeamId) {
      reloadVisibleAccounts(dispatch)
      reloadTeam(dispatch)
      reloadScopes(dispatch)
      dispatch(updateForceRefresh())
      dispatch(setReset())
    }
  }, [selectedTeamId, dispatch])
}